export const tr = {
    'add-placements': {
        one: 'Hedef kitle artırmak için {formats} pano formatını ekleyin',
        some: 'Hedef kitle artırmak için {formats} pano formatlarını ekleyin',
        many: 'Hedef kitle artırmak için {formats} pano formatlarını ekleyin',
        none: 'Hedef kitle artırmak için {formats} pano formatlarını ekleyin'
    },
    title: 'Uygun formatlarda panolar ekleyin',
    'title-hint': 'Seçilen kreatifler için uygun panolar olmadığı için öneri gösterilir',
    'video-format': '{width}x{height}, {duration}sn.'
};
